$( document ).ready(function() {

   $('ul.tabs').each(function(){
      
 var active, content, links = $(this).find('a');
 active = links.first().addClass('active');
 content = $(active.attr('href'));
 links.not(':first').each(function () {
 $($(this).attr('href')).hide();
 });
 $(this).find('a').click(function(e){
 active.removeClass('active');
 content.hide();
 active = $(this);
 content = $($(this).attr('href'));
 active.addClass('active');
 content.show();
 return false;
 });
 });

$('ul.tabss').each(function(){

 var active, content, links = $(this).find('a');

 active = links.first().addClass('active');

 content = $(active.attr('href'));

 links.not(':first').each(function () {

 $($(this).attr('href')).hide();

 });

 $(this).find('a').click(function(e){

 active.removeClass('active');

 content.hide();

 active = $(this);

 content = $($(this).attr('href'));

 active.addClass('active');

 content.show();

 return false;

 });

 });
  
    $("ul.tabs.hm_tb li").click(function(){

      var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');
    $(this).addClass('current');
		$("#"+tab_id).addClass('current');
});

$('.testemonial-slider').slick({
 dots: false,
  infinite: true,
     arrow: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  //product page vertical slider
    $(".vertical_slider").slick({
           slidesToShow: 2,
  slidesToScroll: 1,
            infinite: false,
            vertical: true,
            verticalSwiping: true,
            arrows: true,
            swipeToSlide: true,
            focusOnSelect: true,
          prevArrow:'<button class="slick-prev">More Pics<i class="fa fa-angle-up" aria-hidden="true"></i></button>',
  nextArrow:'<button class="slick-next">More Pics<i class="fa fa-angle-down" aria-hidden="true"></i></button>',
        });
 // Thumbnail Slider J.S Start End
  
});